import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import { loadingToggleAction } from "store/actions/AuthActions";
import { loginAction } from "store/actions/AuthActions";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { errorMessage, showLoading } = useSelector((state) => state.auth);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
 console.log(errorMessage);
  const handleSubmit = (e) => {
    e.preventDefault();   

    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setError(newErrors);
    } else {     
      setError(null);
      setLoading(true);
      const payload = formData;
      dispatch(loadingToggleAction(true));
      dispatch(loginAction(payload, navigate));
     // navigate('/dashboard');
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Email/Mobile required";
    }
    if (!formData.password) {
      newErrors.password = "Password required";
    }
    return newErrors;
  };

  return (
    <>
      <div className="login-area">
        <div className="card panel-custom">
          <div className="card-heading custom_head">
            <div className="view-header">
              <div className="header-icon">
                <i className="pe-7s-unlock"></i>
              </div>
              <div className="header-title">
                <h3>Login</h3>
                <small>
                  <strong>Please enter your credentials to login.</strong>
                </small>
              </div>
            </div>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group">
                <label className="control-label" htmlFor="email">
                  Username
                </label>
                <input
                  type="text"
                  placeholder="example@gmail.com"
                  title="Please enter your email"
                  required
                  value={formData.email}
                  name="email"
                  id="email"
                  className="form-control"
                  onChange={handleChange}
                />
                <span className="help-block small">
                  Your unique email to app
                </span>
                {error?.email && (
                  <p style={{ color: "red" }}>{error.email}</p>
                )}
              </div>

              <div className="form-group">
                <label className="control-label" htmlFor="password">
                  Password
                </label>
                <input
                  type="password"
                  placeholder="******"
                  title="Please enter your password"
                  required
                  value={formData.password}
                  name="password"
                  id="password"
                  className="form-control"
                  onChange={handleChange}
                />
                <span className="help-block small">Your strong password</span>
                {error?.password && (
                  <p style={{ color: "red" }}>{error.password}</p>
                )}
                <div>
                  {errorMessage && (
                    <div
                      className="error"
                      style={{ color: "red", marginBottom: "16px" }}
                    >
                        {errorMessage}
                    </div>
                  )}
                </div>
                <p className="fogot">
                  <a href="forget_password.html">Forgot Password?</a>
                </p>
              </div>
              <div>
                <button
                  className="btn green_btn"
                  type="submit"
                  disabled={showLoading}
                >
                  {showLoading ? "Logging in..." : "Login"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
